import type { Session, Today } from "../../api.ts";
import { tokens, useTheme } from "../../glassTheme.tsx";
import { GlassCard } from "../glass/Glass.tsx";
import { SessionWrite } from "./SessionWrite.tsx";

const PREAMBLE =
  "This is my evening check-in. Read what happened, log anything worth a note and " +
  "update any tasks it affects using the tools available — nothing that isn't there " +
  "already. Then reply in under four lines, plainly, with no praise and no scoring. " +
  "What happened: ";

export function Evening({
  data, doneToday, onOpen, onWritten,
}: { data: Today; doneToday: Session | null; onOpen: (id: string) => void; onWritten: () => void }) {
  const { colors } = useTheme();

  return (
    <div>
      {!data.travel && data.heavy && (
        <GlassCard padding={16} style={{ cursor: "pointer", marginBottom: 16 }} onClick={() => onOpen(data.heavy!.id)}>
          <div style={{
            fontFamily: tokens.font.sans, fontSize: tokens.type.caption.size,
            letterSpacing: tokens.type.caption.letterSpacing, textTransform: "uppercase",
            fontWeight: 600, color: colors.ink2,
          }}>{data.heavy.breadcrumb}</div>
          <div style={{
            fontFamily: tokens.font.serif, fontSize: tokens.type.heavyTitle.size,
            lineHeight: tokens.type.heavyTitle.lineHeight, margin: "6px 0 0", color: colors.ink,
          }}>{data.heavy.title}</div>
        </GlassCard>
      )}

      <GlassCard padding={16}>
        {doneToday ? (
          <DoneSummary session={doneToday} />
        ) : (
          <SessionWrite
            kind="evening" placeholder="What happened" preamble={PREAMBLE} onWritten={onWritten}
          />
        )}
      </GlassCard>
    </div>
  );
}

/**
 * What today's evening record actually holds. Not the original prose — the
 * `/sessions` list endpoint returns `wrote`, not `transcript` — so this
 * shows the outcome, not a replay of what was typed.
 */
function DoneSummary({ session }: { session: Session }) {
  const { colors } = useTheme();
  const wrote = session.wrote as { did?: string[] }[];
  const did = wrote.flatMap((w) => w.did ?? []);
  return (
    <p style={{ margin: 0, fontSize: 14, color: colors.ink2 }}>
      {did.length > 0 ? `Recorded today: ${did.join(" · ")}` : "Recorded today. Nothing was reported."}
    </p>
  );
}
